//

import React from "react";

const BYU_NAVY = "#002E5D";

function Footer() {
    return (
        <footer
            className="footer py-3 mt-auto"
            style={{
                background: BYU_NAVY,
                color: "#fff",
                textAlign: "center",
                letterSpacing: 1,
            }}
        >
            © {new Date().getFullYear()} Adam Griffin
        </footer>
    );
}

export default Footer;